/**
 * Reports Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const reportsRoutes: RouteRecordRaw[] = [
  {
    path: '/reports',
    name: 'reports',
    component: () => import('./views/ReportsLandingView.vue'),
    meta: {
      title: () => i18next.t('nav.reports'),
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [{ label: () => i18next.t('nav.reports') }],
    },
  },
  {
    path: '/reports/soho',
    name: 'reports-soho',
    component: () => import('./views/SohoReportsView.vue'),
    meta: {
      title: () => i18next.t('reports.soho.title'),
      reportNameKey: 'reports.soho.title',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.soho.title') },
      ],
    },
  },
  {
    path: '/reports/soho/annual-activity',
    name: 'reports-annual-activity',
    component: () => import('./views/AnnualActivityReportView.vue'),
    meta: {
      title: () => i18next.t('reports.annual.title'),
      reportNameKey: 'reports.annual.title',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.soho.title'), to: '/reports/soho' },
        { label: () => i18next.t('reports.annual.title') },
      ],
    },
  },
  {
    path: '/reports/feed-order',
    name: 'reports-feed-order',
    component: () => import('./views/FeedOrderReportView.vue'),
    meta: {
      title: () => i18next.t('reports.feedOrder.title'),
      reportNameKey: 'reports.feedOrder.title',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.feedOrder.title') },
      ],
    },
  },
  {
    path: '/reports/feed-administration',
    name: 'reports-feed-administration',
    component: () => import('./views/FeedAdministrationReportView.vue'),
    meta: {
      title: () => i18next.t('reports.feedAdmin.title'),
      reportNameKey: 'reports.feedAdmin.title',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.feedAdmin.title') },
      ],
    },
  },
  {
    path: '/reports/inventory',
    name: 'reports-inventory',
    component: () => import('./views/InventoryReportView.vue'),
    meta: {
      title: () => i18next.t('reports.inventoryStatus'),
      reportNameKey: 'reports.inventoryStatus',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.inventoryStatus') },
      ],
    },
  },
  {
    path: '/reports/soho/gdprCompliance',
    name: 'reports-gdpr-compliance',
    component: () => import('./views/GdprComplianceReportView.vue'),
    meta: {
      title: () => i18next.t('reports.gdpr.title'),
      reportNameKey: 'reports.gdpr.title',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.soho.title'), to: '/reports/soho' },
        { label: () => i18next.t('reports.gdpr.title') },
      ],
    },
  },
  {
    path: '/reports/error-safety-audit',
    name: 'reports-error-safety-audit',
    component: () => import('./views/ErrorSafetyAuditView.vue'),
    meta: {
      title: () => i18next.t('reports.errorSafetyAudit'),
      reportNameKey: 'reports.errorSafetyAudit',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.errorSafetyAudit') },
      ],
    },
  },
  {
    path: '/reports/soho/traceability',
    name: 'reports-traceability',
    component: () => import('./views/TraceabilityReportView.vue'),
    meta: {
      title: () => i18next.t('reports.soho.traceabilityReport'),
      reportNameKey: 'reports.soho.traceabilityReport',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.soho.title'), to: '/reports/soho' },
        { label: () => i18next.t('reports.soho.traceabilityReport') },
      ],
    },
  },
  {
    path: '/reports/soho/traceability/receivable/:id',
    name: 'reports-traceability-receivable',
    component: () => import('./views/TraceabilityReceivableLifecycleView.vue'),
    meta: {
      title: () => i18next.t('reports.soho.traceability.journey.title.receivable'),
      reportNameKey: 'reports.soho.traceabilityReport',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.soho.title'), to: '/reports/soho' },
        { label: () => i18next.t('reports.soho.traceabilityReport'), to: '/reports/soho/traceability' },
        { label: () => i18next.t('reports.soho.traceability.journey.title.receivable') },
      ],
    },
  },
  {
    path: '/reports/soho/traceability/batch-bottle/:id',
    name: 'reports-traceability-batch-bottle',
    component: () => import('./views/TraceabilityBatchBottleLifecycleView.vue'),
    meta: {
      title: () => i18next.t('reports.soho.traceability.journey.title.batchBottle'),
      reportNameKey: 'reports.soho.traceabilityReport',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.soho.title'), to: '/reports/soho' },
        { label: () => i18next.t('reports.soho.traceabilityReport'), to: '/reports/soho/traceability' },
        { label: () => i18next.t('reports.soho.traceability.journey.title.batchBottle') },
      ],
    },
  },
  {
    path: '/reports/soho/traceability/feed/:id',
    name: 'reports-traceability-feed',
    component: () => import('./views/TraceabilityFeedLifecycleView.vue'),
    meta: {
      title: () => i18next.t('reports.soho.traceability.journey.title.feed'),
      reportNameKey: 'reports.soho.traceabilityReport',
      requiredEntitlement: 'REPORTS',
      breadcrumbs: [
        { label: () => i18next.t('nav.reports'), to: '/reports' },
        { label: () => i18next.t('reports.soho.title'), to: '/reports/soho' },
        { label: () => i18next.t('reports.soho.traceabilityReport'), to: '/reports/soho/traceability' },
        { label: () => i18next.t('reports.soho.traceability.journey.title.feed') },
      ],
    },
  },
];
